import React from 'react';

interface ViewToggleProps {
  viewMode: 'map' | 'list';
  onViewModeChange: (mode: 'map' | 'list') => void;
}

const ViewToggle: React.FC<ViewToggleProps> = ({ viewMode, onViewModeChange }) => {
  const toggleView = () => {
    onViewModeChange(viewMode === 'map' ? 'list' : 'map');
  };

  const icon = viewMode === 'map' ? 'list' : 'location-pin';
  const label = viewMode === 'map' ? 'List View' : 'Map View';
  const title = viewMode === 'map' ? 'Switch to List View' : 'Switch to Map View';

  return (
    <button
      type="button"
      className="wmnds-btn wmnds-btn--secondary wmnds-float--right"
      onClick={toggleView}
      // Prevent duplicate toggles: only the primary `onClick` should
      // perform the toggle. Pointer/touch handlers are retained to
      // avoid unwanted defaults but MUST NOT call `toggleView` again.
      onPointerUp={(e) => { try { e.preventDefault(); } catch (err) {} }}
      onTouchEnd={(e) => { try { e.preventDefault(); } catch (err) {} }}
      title={title}
    >
      {label}
      <svg className="wmnds-btn__icon wmnds-btn__icon--right">
        <use
          xlinkHref={`#wmnds-general-${icon}`}
          href={`#wmnds-general-${icon}`}
        ></use>
      </svg>
    </button>
  );
};

export default ViewToggle;
